import Vue from 'vue'
import moment from 'moment'//导入文件 
Vue.filter('formatDate', function (value) {
    return Moment(value).format('YYYY-MM-DD HH:mm:ss')
})
Vue.prototype.$moment = moment;//赋值使用